<template>
  <v-app>
    <div class="page-container">
      <div class="navbar-container">
        <Navbar :title="$t('text_payment')" showCloseButton />
      </div>
      <v-container class="main-container pt-0">
        <v-card elevation="1" class="rounded-lg mb-4 mt-2">
          <v-card-text>
            <div class="d-flex align-center justify-space-between">
              <div class="d-flex align-center" style="gap: 14px">
                <div class="image-payment mr-2">
                  <v-img :src="orderData?.payment_log?.payment_image" style="max-width: 60px"></v-img>
                </div>
                <div class="d-flex flex-column">
                  <v-card-title class="pb-0 py-1 font-weight-bold black--text body-1">{{
                    orderData?.payment_log?.va_account_number
                  }}</v-card-title>
                  <v-card-text class="pb-1 pt-0">{{
                    orderData?.payment_log?.payment_type
                  }}</v-card-text>
                </div>
              </div>

              <div class="va-card-number">
                <input id="va_account_number" type="hidden" :value="orderData.payment_log.va_account_number" />
                <v-btn class="ml-2" text icon color="primary" @click="copyText(orderData.payment_log.va_account_number)">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="20" width="20" viewBox="0 0 24 24">
                    <path
                      d="M19,21H8V7H19M19,5H8A2,2 0 0,0 6,7V21A2,2 0 0,0 8,23H19A2,2 0 0,0 21,21V7A2,2 0 0,0 19,5M16,1H4A2,2 0 0,0 2,3V17H4V3H16V1Z" />
                  </svg>
                </v-btn>
              </div>
            </div>
            <v-divider />
            <div class="d-flex align-center justify-space-between black--text mt-4">
              <span class="body-1">Total</span>
              <span class="body-1">{{ orderData?.ftotal_amount }}</span>
            </div>
            <div class="countdown my-2">
              <div class="qris-countdown">
                <div class="qris-countdown-icon warning--text">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="24" width="24" viewBox="0 0 24 24">
                    <path d="M12,2L1,21H23M12,6L19.53,19H4.47M11,10V14H13V10M11,16V18H13V16" />
                  </svg>
                </div>
                <div class="qris-countdown-content">
                  <div class="qris-countdown-title">
                    {{ $t('text_please_do_payment') }}
                    <b>{{ $t('text_time_left_to_pay') }}: {{ formattedTimeLeft }}</b>
                  </div>
                </div>
              </div>
            </div>
            <v-btn block outlined color="primary" height="40" class="text-none" @click="panduanPembayaran = true">
              {{ $t('text_panduan_pembayaran') }}
            </v-btn>
          </v-card-text>
        </v-card>

        <v-card elevation="1" class="rounded-lg mb-8 mt-4">
          <div class="d-flex align-center justify-start">
            <v-avatar class="ma-3 rounded-lg" size="50" tile>
              <v-img :src="storeData?.logo" style="border-radius: 50px"></v-img>
            </v-avatar>
            <v-card-title class="pb-0 py-0 font-weight-bold">{{
              storeData?.name
            }}</v-card-title>
          </div>
          <v-card-text>
            <v-divider />
            <div class="d-flex flex-column mt-2">
              <div class="d-flex justify-space-between align-center">
                <div class="d-flex flex-column">
                  <span class="text-caption">{{ $t('text_order_no') }}</span>
                  <span class="font-weight-bold" style="font-size: large">{{
                    orderData?.order_no
                  }}</span>
                </div>
                <v-chip class="rounded-lg" small>
                  <svg width="12" height="14" viewBox="0 0 12 14" fill="none" class="mr-2"
                    xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M12 13.6668H2C1.196 13.6668 0 13.1342 0 11.6668V10.3335V8.3335V4.3335V2.3335C0 0.866163 1.196 0.333496 2 0.333496H10.6667C11.402 0.333496 12 0.931496 12 1.66683V9.00016V10.3335V11.0002H11.3333H10.6667H2.008C1.7 11.0082 1.33333 11.1302 1.33333 11.6668C1.33333 12.2035 1.7 12.3255 2.008 12.3335H12V13.6668ZM1.33333 2.3335V4.3335V8.3335V9.66683H10.6667V9.00016V1.66683H2C1.7 1.67483 1.33333 1.79683 1.33333 2.3335ZM9.33333 3.00016H3.33333V4.3335H9.33333V3.00016Z"
                      fill="#272727" />
                  </svg>
                  {{ $t('text_reservation') }}
                </v-chip>
              </div>
              <div class="d-flex justify-space-between align-center mt-2">
                <span class="font-weight-normal">{{ $t('text_order_date') }}</span>
                <span>{{ orderData?.forder_date }}</span>
              </div>
            </div>
          </v-card-text>
        </v-card>

        <v-card elevation="2" class="rounded-lg mb-4 mt-4">
          <div class="d-flex flex-column">
            <div v-for="(item, index) in placeReservation" :key="index">
              <div class="d-flex justify-start">
                <v-avatar class="ma-3 rounded-lg" size="90" tile>
                  <v-img style="border-radius: 10px;" :src="item?.photo_md"></v-img>
                </v-avatar>
                <v-card-text class="d-flex flex-column pl-0">
                  <div class="d-flex justify-space-between align-center">
                    <span class="d-flex align-center font-weight-regular">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="#767676" width="14" height="14"
                            class="mr-2" viewBox="0 0 24 24">
                            <path
                                d="M9,10V12H7V10H9M13,10V12H11V10H13M17,10V12H15V10H17M19,3A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5C3.89,21 3,20.1 3,19V5A2,2 0 0,1 5,3H6V1H8V3H16V1H18V3H19M19,19V8H5V19H19M9,14V16H7V14H9M13,14V16H11V14H13M17,14V16H15V14H17Z" />
                        </svg>
                        {{ item.freserv_date }}
                    </span>

                    <v-chip class="rounded-lg" small color="primary">
                      <svg xmlns="http://www.w3.org/2000/svg" class="mr-2" fill="currentColor" width="14" height="14"
                        viewBox="0 0 24 24">
                        <path
                          d="M12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22C6.47,22 2,17.5 2,12A10,10 0 0,1 12,2M12.5,7V12.25L17,14.92L16.25,16.15L11,13V7H12.5Z" />
                      </svg>
                      {{ item.freserv_time }}
                    </v-chip>
                  </div>
                  <span class="d-flex align-center text-caption">
                    <svg class="mr-2" width="14" height="14" viewBox="0 0 14 11" fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M1.9981 0.166687C1.34647 0.166687 0.790305 0.637677 0.682974 1.2804L0.348987 3.2804C0.213248 4.09324 0.840021 4.83335 1.66411 4.83335H2.71382V10.3426C2.71382 10.6137 2.93352 10.8334 3.20453 10.8334C3.44967 10.8334 3.6572 10.6525 3.69066 10.4096L4.09151 7.50002H9.90845L10.3093 10.4096C10.3428 10.6525 10.5503 10.8334 10.7954 10.8334C11.0664 10.8334 11.2861 10.6137 11.2861 10.3426V4.83335H12.3358C13.1599 4.83335 13.7867 4.09324 13.651 3.2804L13.317 1.2804C13.2097 0.637678 12.6535 0.166687 12.0019 0.166687H1.9981ZM9.72476 6.16669L9.5536 4.92434C9.54938 4.89371 9.54731 4.86334 9.54725 4.83335H4.45272C4.45266 4.86333 4.45058 4.89371 4.44636 4.92434L4.27521 6.16669H9.72476ZM1.9981 1.50002L12.0019 1.50002L12.3358 3.50002L1.66411 3.50002L1.9981 1.50002Z"
                        fill="#767676" />
                    </svg>
                    {{ item.layout_item_name }}
                  </span>
                  <span class="d-flex align-center font-weight-regular">
                    <svg class="mr-2" width="17" height="17" viewBox="0 0 17 17" fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M8.66663 1.83331C6.82863 1.83331 5.33329 3.32865 5.33329 5.16665C5.33329 7.00465 6.82863 8.49998 8.66663 8.49998C10.5046 8.49998 12 7.00465 12 5.16665C12 3.32865 10.5046 1.83331 8.66663 1.83331ZM8.66663 7.16665C7.56396 7.16665 6.66663 6.26931 6.66663 5.16665C6.66663 4.06398 7.56396 3.16665 8.66663 3.16665C9.76929 3.16665 10.6666 4.06398 10.6666 5.16665C10.6666 6.26931 9.76929 7.16665 8.66663 7.16665ZM14.6666 14.5V13.8333C14.6666 11.2606 12.5726 9.16665 9.99996 9.16665H7.33329C4.75996 9.16665 2.66663 11.2606 2.66663 13.8333V14.5H3.99996V13.8333C3.99996 11.9953 5.49529 10.5 7.33329 10.5H9.99996C11.838 10.5 13.3333 11.9953 13.3333 13.8333V14.5H14.6666Z"
                        fill="#767676" />
                    </svg>
                    {{ item?.capacity ?? "-" }} {{ $t('text_persons') }}
                  </span>
                  <div class="price mt-1" style="font-size: 1rem" :style="item?.with_special_price === 1 ? 'color: #7b7b7b!important;text-decoration: line-through' : ''">
                    {{ formatCurrency(item.price, true) }}
                  </div>
                  <div v-if="item?.with_special_price === 1" class="price" style="font-size: 1rem;">
                    {{ formatCurrency(item.special_price, true) }}
                  </div>
                </v-card-text>
              </div>
              <v-divider v-if="index < placeReservation.length - 1" class="mx-3"></v-divider>
            </div>
          </div>
        </v-card>

        <div class="payment-detail mb-6">
          <span class="font-weight-bold">{{ $t('text_price') }}</span>
          <div class="d-flex justify-space-between align-center mt-2">
            <span class="font-weight-medium">Subtotal</span>
            <v-spacer />
            <span class="font-weight-medium">{{
              orderData?.forder_amount
            }}</span>
          </div>
          <div class="d-flex justify-space-between align-center mt-2">
            <span class="font-weight-medium">{{ $t('text_admin_fee') }}</span>
            <v-spacer />
            <span class="font-weight-medium">{{
              orderData?.ftrans_fee_amount
            }}</span>
          </div>
          <!--<div class="d-flex justify-space-between align-center mt-2">
            <span class="font-weight-medium">Tax</span>
            <v-spacer />
            <span class="font-weight-medium">{{ orderData?.ftax_amount }}</span>
          </div>-->
          <div class="d-flex justify-space-between align-center mt-8">
            <span class="font-weight-medium">Total</span>
            <v-spacer />
            <span class="font-weight-medium">{{
              orderData?.ftotal_amount
            }}</span>
          </div>
        </div>

        <v-btn block color="primary" height="40" class="text-none mb-2" :disabled="getLoadingAxiosState || loading_payment" rounded @click="handleCheckUpdate">
          {{ $t('text_update_status_payment') }}
        </v-btn>
        <v-btn block outlined color="primary" height="40" class="text-none mb-2" rounded @click="backToHome">
          {{ $t('text_back_to_menu') }}
        </v-btn>
        <v-btn block outlined color="error" height="40" class="text-none mb-2" :disabled="getLoadingAxiosState || loading_payment" rounded
          @click="dialog.dialogCancelOrder = true">
          {{ $t('text_cancel_order') }}
        </v-btn>
      </v-container>

      <v-snackbar v-model="snackbar.show" :color="snackbar.color">
        <div class="d-flex align-center justify-space-between" style="width: 100%">
          <span>{{ snackbar.text }}</span>
          <v-btn class="transparent" text fab x-small dark @click="snackbar.show = false">
            <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="24" height="24" viewBox="0 0 24 24">
              <path
                d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" />
            </svg>
          </v-btn>
        </div>
      </v-snackbar>

      <v-snackbar
        v-model="dataSuccess.show"
        top
        :multi-line="true"
        color="#E9FBE9"
      >
          <div class="d-flex align-center justify-space-between success--text">
            <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="24" height="24" viewBox="0 0 24 24"><path d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" /></svg>
            <span class="ml-2">Pesanan berhasil dibatalkan</span>
          </div>
      </v-snackbar>

      <v-dialog v-model="dialog.dialogCancelOrder" max-width="290">
        <v-card>
          <v-card-title class="headline"> Konfirmasi </v-card-title>
          <v-card-text>
            {{ $t('text_confirmation_question') }}
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="grey" text @click="dialog.dialogCancelOrder = false">
              {{ $t('text_no') }}
            </v-btn>
            <v-btn color="primary" :disabled="getLoadingAxiosState || loading_payment" outlined @click="cancelOrderReservation()">
              {{ $t('text_yes') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-bottom-sheet v-model="panduanPembayaran" inset max-width="480px">
        <v-sheet class="px-3 py-2 sheet" style="border-top-left-radius: 10px; border-top-right-radius: 10px;">
          <div class="sheet-content">
          <div class="pa-4">
            <h4 class="title-va">
              {{ $t('text_panduan_pembayaran') }}
            </h4>
            <v-expansion-panels v-if="orderData.payment_log && orderData.payment_log.va_bank_code" flat class="panel-guide mt-4">
              <template v-if="orderData.payment_log.va_bank_code === 'MANDIRI'">
                <v-expansion-panel>
                  <v-expansion-panel-header class="px-0 py-3 subtitle-1">
                    ATM
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <ol>
                      <li>
                        Masukkan kartu ATM dan pilih "Bahasa Indonesia"
                      </li>
                      <li>
                        Ketik nomor PIN dan tekan BENAR
                      </li>
                      <li>
                        Pilih menu “BAYAR/BELI”
                      </li>
                      <li>
                        Pilih menu “MULTI PAYMENT”
                      </li>
                      <li>
                        Ketik kode perusahaan, yaitu "88908" (Xendit 88908), tekan "BENAR"
                      </li>
                      <li>
                        Masukkan nomor Virtual Account (<strong>{{ orderData.payment_log.va_account_number }}</strong>)
                      </li>
                      <li>
                        Isi NOMINAL, kemudian tekan "BENAR"
                      </li>
                      <li>
                        Muncul konfirmasi data customer. Pilih Nomor 1 sesuai tagihan yang akan dibayar, kemudian tekan "YA"
                      </li>
                      <li>
                        Muncul konfirmasi pembayaran. Tekan "YA" untuk melakukan pembayaran
                      </li>
                      <li>
                        Bukti pembayaran dalam bentuk struk agar disimpan sebagai bukti pembayaran yang sah dari Bank Mandiri
                      </li>
                      <li>
                        Transaksi Anda sudah selesai
                      </li>
                    </ol>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <v-expansion-panel-header class="subtitle-1">
                    Mobile Banking
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <ol>
                      <li>
                        Log in Mobile Banking Mandiri Online
                      </li>
                      <li>
                        Klik “Icon Menu” di sebelah kiri atas
                      </li>
                      <li>
                        Pilih menu “Pembayaran”
                      </li>
                      <li>
                        Pilih “Buat Pembayaran Baru”
                      </li>
                      <li>
                        Pilih “Multi Payment”
                      </li>
                      <li>
                        Pilih Penyedia Jasa “Xendit 88908”
                      </li>
                      <li>
                        Pilih “No. Virtual”
                      </li>
                      <li>
                        Masukkan no virtual account anda (<strong>{{ orderData.payment_log.va_account_number }}</strong>) lalu pilih “Tambah Sebagai Nomor Baru”
                      </li>
                      <li>
                        Masukkan “Nominal” lalu pilih “Konfirmasi”
                      </li>
                      <li>
                        Pilih “Lanjut”
                      </li>
                      <li>
                        Muncul tampilan konfirmasi pembayaran
                      </li>
                      <li>
                        Scroll ke bawah di tampilan konfirmasi pembayaran lalu pilih “Konfirmasi”
                      </li>
                      <li>
                        Masukkan “PIN” dan transaksi telah selesai
                      </li>
                    </ol>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <v-expansion-panel-header class="subtitle-1">
                    Internet Banking
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <ol>
                      <li>
                        Kunjungi website Mandiri Internet Banking:
                        <a href="https://ibank.bankmandiri.co.id/retail3/" target="_blank">
                          klik disini
                        </a>
                      </li>
                      <li>
                        Login dengan memasukkan USER ID dan PIN
                      </li>
                      <li>
                        Pilih "Pembayaran"
                      </li>
                      <li>
                        Pilih "Multi Payment"
                      </li>
                      <li>
                        Pilih "No Rekening Anda"
                      </li>
                      <li>
                        Pilih Penyedia Jasa "Xendit 88908"
                      </li>
                      <li>
                        Pilih "No Virtual Account"
                      </li>
                      <li>
                        Masukkan nomor Virtual Account anda (<strong>{{ orderData.payment_log.va_account_number }}</strong>)
                      </li>
                      <li>
                        Masuk ke halaman konfirmasi 1
                      </li>
                      <li>
                        Apabila benar/sesuai, klik tombol tagihan TOTAL, kemudian klik "LANJUTKAN"
                      </li>
                      <li>
                        Masuk ke halaman konfirmasi 2
                      </li>
                      <li>
                        Masukkan Challenge Code yang dikirimkan ke Token Internet Banking Anda, kemudian klik "Kirim"
                      </li>
                      <li>
                        Anda akan masuk ke halaman konfirmasi jika pembayaran telah selesai
                      </li>
                    </ol>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </template>
              <template v-if="orderData.payment_log.va_bank_code === 'BNI'">
                <v-expansion-panel>
                  <v-expansion-panel-header class="subtitle-1">
                    ATM
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <ol>
                      <li>
                        {{ $t('atm.li1') }}
                      </li>
                      <li>
                        {{ $t('atm.li2') }}
                      </li>
                      <li>
                        {{ $t('atm.li3') }}
                      </li>
                      <li>
                        {{ $t('atm.li4') }}
                      </li>
                      <li>
                        {{ $t('atm.li5') }}
                      </li>
                      <li>
                        {{ $t('atm.li6') }}
                      </li>
                      <li>
                        {{ $t('atm.li7') }}
                      </li>
                      <li>
                        {{ $t('atm.li8') }} (<strong>{{ orderData.payment_log.va_account_number }}</strong>).
                      </li>
                      <li>
                        {{ $t('atm.li9') }}
                      </li>
                      <li>
                        {{ $t('atm.li10') }}
                      </li>
                    </ol>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <v-expansion-panel-header class="subtitle-1">
                    Mobile Banking BNI
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <ol>
                      <li>
                        {{ $t('mbangking.li1') }}
                      </li>
                      <li>
                        {{ $t('mbangking.li2') }}
                      </li>
                      <li>
                        {{ $t('mbangking.li3') }}
                      </li>
                      <li>
                        {{ $t('mbangking.li4-1') }} (<strong>{{ orderData.payment_log.va_account_number }}</strong>) {{ $t('mbangking.li4-2') }}
                      </li>
                      <li>
                        {{ $t('mbangking.li5') }}
                      </li>
                      <li>
                        {{ $t('mbangking.li6') }}
                      </li>
                      <li>
                        {{ $t('mbangking.li7') }}
                      </li>
                    </ol>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <v-expansion-panel-header class="subtitle-1">
                    Internet Banking BNI
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <ol>
                      <li>
                        {{ $t('internet-banking.li1-1') }}
                        <a href="https://ibank.bni.co.id" target="_blank">{{ $t('internet-banking.li1-2') }}</a>.
                      </li>
                      <li>
                        {{ $t('internet-banking.li2') }}
                      </li>
                      <li>
                        {{ $t('internet-banking.li3') }}
                      </li>
                      <li>
                        {{ $t('internet-banking.li4') }}
                      </li>
                      <li>
                        {{ $t('internet-banking.li5-1') }} (<strong>{{ orderData.payment_log.va_account_number }}</strong>) {{ $t('internet-banking.li5-2') }}
                      </li>
                      <li>
                        {{ $t('internet-banking.li6') }}
                      </li>
                      <li>
                        {{ $t('internet-banking.li7') }}
                      </li>
                      <li>
                        {{ $t('internet-banking.li8') }}
                      </li>
                    </ol>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </template>
              <template v-if="orderData.payment_log.va_bank_code === 'BRI'">
                <v-expansion-panel>
                  <v-expansion-panel-header class="px-0 py-3 subtitle-1">
                    ATM
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <ol>
                      <li>
                        Pilih menu Transaksi Lain
                      </li>
                      <li>
                        Pilih menu Lainnya
                      </li>
                      <li>
                        Pilih menu Pembayaran
                      </li>
                      <li>
                        Pilih menu Lainnya
                      </li>
                      <li>
                        Pilih menu BRIVA
                      </li>
                      <li>
                        Masukkan Nomor BRI Virtual Account (<strong>{{ orderData.payment_log.va_account_number }}</strong>), lalu tekan “Benar”
                      </li>
                      <li>
                        Konfirmasi pembayaran, tekan “Ya” bila sesuai
                      </li>
                    </ol>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <v-expansion-panel-header class="px-0 py-3 subtitle-1">
                    Mobile Banking
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <ol>
                      <li>
                        Log in ke Mobile Banking
                      </li>
                      <li>
                        Pilih menu Pembayaran
                      </li>
                      <li>
                        Pilih menu BRIVA
                      </li>
                      <li>
                        Masukkan nomor BRI Virtual Account (<strong>{{ orderData.payment_log.va_account_number }}</strong>) dan jumlah pembayaran
                      </li>
                      <li>
                        Masukkan nomor PIN anda
                      </li>
                      <li>
                        Tekan “OK” untuk melanjutkan transaksi
                      </li>
                      <li>
                        Transaksi berhasil
                      </li>
                      <li>
                        SMS konfirmasi akan masuk ke nomor telepon anda
                      </li>
                    </ol>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <v-expansion-panel-header class="px-0 py-3 subtitle-1">
                    Internet Banking
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <ol>
                      <li>
                        Masukan User ID dan Password
                      </li>
                      <li>
                        Pilih menu Pembayaran
                      </li>
                      <li>
                        Pilih menu BRIVA
                      </li>
                      <li>
                        Pilih rekening Pembayar
                      </li>
                      <li>
                        Masukkan Nomor Virtual Account BRI Anda (<strong>{{ orderData.payment_log.va_account_number }}</strong>)
                      </li>
                      <li>
                        Masukkan nominal yang akan dibayar
                      </li>
                      <li>
                        Masukkan password dan Mtoken anda
                      </li>
                    </ol>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </template>
              <template v-if="orderData.payment_log.va_bank_code === 'PERMATA'">
                <v-expansion-panel>
                  <v-expansion-panel-header class="px-0 py-3 subtitle-1">
                    ATM PRIMA / ALTO:
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <ol>
                      <li>
                        Pada menu utama, pilih transaksi lain
                      </li>
                      <li>
                        Pilih Pembayaran Transfer
                      </li>
                      <li>
                        Pilih pembayaran lainnya
                      </li>
                      <li>
                        Pilih pembayaran Virtual Account
                      </li>
                      <li>
                        Masukkan nomor virtual account anda (<strong>{{ orderData.payment_log.va_account_number }}</strong>)
                      </li>
                      <li>
                        Pada halaman konfirmasi, akan muncul nominal yang dibayarkan, nomor, dan nama merchant, lanjutkan jika sudah sesuai
                      </li>
                      <li>
                        Pilih sumber pembayaran anda dan lanjutkan
                      </li>
                      <li>
                        Transaksi anda selesai
                      </li>
                      <li>
                        Ketika transaksi anda sudah selesai, invoice anda akan diupdate secara otomatis. Ini mungkin memakan waktu hingga 5 menit.
                      </li>
                    </ol>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <v-expansion-panel-header class="px-0 py-3 subtitle-1">
                    Permata Mobile X
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <ol>
                      <li>
                        Buka Permata Mobile X dan Login
                      </li>
                      <li>
                        Pilih Pay "Pay Bills"/ "Pembayaran Tagihan"
                      </li>
                      <li>
                        Pilih “Virtual Account”
                      </li>
                      <li>
                        Masukkan Nomor Virtual Account anda (<strong>{{ orderData.payment_log.va_account_number }}</strong>)
                      </li>
                      <li>
                        Detail pembayaran anda akan muncul di layar
                      </li>
                      <li>
                        Nominal yang ditagihkan akan muncul di layar. Pilih sumber pembayaran
                      </li>
                      <li>
                        Konfirmasi transaksi anda
                      </li>
                      <li>
                        Masukkan kode response token anda
                      </li>
                      <li>
                        Transaksi anda telah selesai
                      </li>
                      <li>
                        Ketika transaksi anda sudah selesai, invoice anda akan diupdate secara otomatis. Ini mungkin memakan waktu hingga 5 menit.
                      </li>
                    </ol>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <v-expansion-panel-header class="px-0 py-3 subtitle-1">
                    Permata Mobile
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <ol>
                      <li>
                        Buka Permata Mobile dan Login
                      </li>
                      <li>
                        Pilih Pay "Pay Bills"/ "Pembayaran Tagihan"
                      </li>
                      <li>
                        Pilih menu “Transfer”
                      </li>
                      <li>
                        Pilih sumber pembayaran
                      </li>
                      <li>
                        Pilih “daftar tagihan baru”
                      </li>
                      <li>
                        Masukan nomor Virtual Account Anda (<strong>{{ orderData.payment_log.va_account_number }}</strong>)
                      </li>
                      <li>
                        Periksa ulang mengenai transaksi yang anda ingin lakukan
                      </li>
                      <li>
                        Konfirmasi transaksi anda
                      </li>
                      <li>
                        Masukkan SMS token respons
                      </li>
                      <li>
                        Pembayaran Anda berhasil
                      </li>
                      <li>
                        Ketika transaksi anda sudah selesai, invoice anda akan diupdate secara otomatis. Ini mungkin memakan waktu hingga 5 menit.
                      </li>
                    </ol>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <v-expansion-panel-header class="px-0 py-3 subtitle-1">
                    Internet Banking Permata (PermataNet)
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <ol>
                      <li>
                        Buka situs https://new.permatanet.com atau
                        <a href="https://new.permatanet.com" target="_blank">klik disini</a>
                        dan login
                      </li>
                      <li>
                        Pilih menu “pembayaran”.
                      </li>
                      <li>
                        Pilih menu “Pembayaran Tagihan”.
                      </li>
                      <li>
                        Pilih “Virtual Account”
                      </li>
                      <li>
                        Pilih sumber pembayaran
                      </li>
                      <li>
                        Pilih menu "Masukkan Daftar Tagihan Baru"
                      </li>
                      <li>
                        Masukan nomor Virtual Account Anda (<strong>{{ orderData.payment_log.va_account_number }}</strong>)
                      </li>
                      <li>
                        Konfirmasi transaksi anda
                      </li>
                      <li>
                        Masukkan SMS token response
                      </li>
                      <li>
                        Pembayaran Anda berhasil
                      </li>
                      <li>
                        Ketika transaksi anda sudah selesai, invoice anda akan diupdate secara otomatis. Ini mungkin memakan waktu hingga 5 menit
                      </li>
                    </ol>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </template>
              <template v-if="orderData.payment_log.va_bank_code === 'BCA'">
                <v-expansion-panel>
                  <v-expansion-panel-header class="px-0 py-3 subtitle-1">
                    ATM
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <ol>
                      <li>
                        Masukkan kartu ATM dan PIN BCA Anda
                      </li>
                      <li>
                        Di menu utama, pilih "Transaksi Lainnya". Pilih "Transfer". Pilih "Ke BCA Virtual Account"
                      </li>
                      <li>
                        Masukkan nomor Virtual Account <strong>{{ orderData.payment_log.va_account_number }}</strong>
                      </li>
                      <li>
                        Pastikan data Virtual Account Anda benar, kemudian masukkan angka yang perlu Anda bayarkan, kemudian pilih "Benar"
                      </li>
                      <li>
                        Cek dan perhatikan konfirmasi pembayaran dari layar ATM, jika sudah benar pilih "Ya", atau pilih "Tidak" jika data di layar masih salah
                      </li>
                      <li>
                        Transaksi Anda sudah selesai. Pilih "Tidak" untuk tidak melanjutkan transaksi lain
                      </li>
                      <li>
                        Setelah transaksi pembayaran Anda selesai, invoice ini akan diperbarui secara otomatis. Ini bisa memakan waktu hingga 5 menit.
                      </li>
                    </ol>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <v-expansion-panel-header class="px-0 py-3 subtitle-1">
                    IBanking
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <ol>
                      <li>
                        Login ke KlikBCA Individual
                      </li>
                      <li>
                        Pilih "Transfer", kemudian pilih "Transfer ke BCA Virtual Account"
                      </li>
                      <li>
                        Masukkan nomor Virtual Account <strong>{{ orderData.payment_log.va_account_number }}</strong>
                      </li>
                      <li>
                        Pilih "Lanjutkan" untuk melanjutkan pembayaran
                      </li>
                      <li>
                        Masukkan "RESPON KEYBCA APPLI 1" yang muncul pada Token BCA Anda, lalu klik tombol "Kirim"
                      </li>
                      <li>
                        Transaksi Anda sudah selesai
                      </li>
                      <li>
                        Setelah transaksi pembayaran Anda selesai, invoice ini akan diperbarui secara otomatis. Ini bisa memakan waktu hingga 5 menit.
                      </li>
                    </ol>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <v-expansion-panel-header class="px-0 py-3 subtitle-1">
                    BCA M-Mobile
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <ol>
                      <li>
                        Buka Aplikasi BCA Mobile
                      </li>
                      <li>
                        Pilih "m-BCA", kemudian pilih "m-Transfer"
                      </li>
                      <li>
                        Pilih "BCA Virtual Account"
                      </li>
                      <li>
                        Masukkan nomor Virtual Account <strong>{{ order.payment_log.va_account_number }}</strong>, lalu pilih "OK"
                      </li>
                      <li>
                        Klik tombol "Send" yang berada di sudut kanan atas aplikasi untuk melakukan transfer
                      </li>
                      <li>
                        Klik "OK" untuk melanjutkan pembayaran
                      </li>
                      <li>
                        Masukkan PIN Anda untuk meng-otorisasi transaksi
                      </li>
                      <li>
                        Setelah transaksi pembayaran Anda selesai, invoice ini akan diperbarui secara otomatis. Ini bisa memakan waktu hingga 5 menit.
                      </li>
                    </ol>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </template>
            </v-expansion-panels>
          </div>
          </div>
        </v-sheet>
      </v-bottom-sheet>
    </div>
  </v-app>
</template>

<script>
import Navbar from "@/components/Layouts/Navbar.vue";
import { mapGetters } from "vuex";
import { formatCurrency } from "@/utils/currencyUtils";
import { getSelfOrder, cancelOrder } from "@/api/payment";
import { setQueryParam, removeAllQueryParams } from '@/utils/customQuery'
export default {
  name: "PymentVa",
  components: {
    Navbar,
  },
  data() {
    return {
      timerOrderInterval: null,
      distance: 0,
      panduanPembayaran: false,
      dialog: {
        dialogCancelOrder: false,
      },
      snackbar: {
        show: false,
        color: "",
        text: "",
      },
      dataSuccess: {
        show: false,
        text: "",
      },
      loading_payment: false,
    };
  },
  computed: {
    storeData() {
      return this.$store.getters.getStoreData;
    },
    placeReservation() {
      return this.$store.getters.orderData?.place_reservation ?? [];
    },
    ...mapGetters(["orderData","getLoadingAxiosState"]),
    formattedTimeLeft() {
      let days = Math.floor(this.distance / (1000 * 60 * 60 * 24));
      let hours = Math.floor(
        (this.distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      let minutes = Math.floor(
        (this.distance % (1000 * 60 * 60)) / (1000 * 60)
      );
      let seconds = Math.floor((this.distance % (1000 * 60)) / 1000);
      let result;
      if (this.distance < 0) {
        result = "EXPIRED";
      } else {
        days = days === 0 ? "" : days + " : ";
        hours =
          hours < 10 ? (hours === 0 ? "" : "0" + hours + " : ") : hours + " : ";
        minutes = minutes < 10 ? "0" + minutes + ":" : minutes + ":";
        seconds = seconds < 10 ? "0" + seconds : seconds;
        result = days + hours + minutes + seconds;
      }
      return result;
    },
  },
  mounted() {
    if (this.orderData) {
      if (this.orderData.payment_log && this.orderData.payment_log.expired_at) {
        this.getExpiryTime(this.orderData.payment_log.expired_at);
      }
      if (this.orderData.is_paid) {
        clearInterval(this.timerOrderInterval);
      }
    }
  },
  methods: {
    formatCurrency,
    getExpiryTime(time) {
      var countDownDate = new Date(time).getTime();
      const _this = this;
      this.timerInterval = setInterval(function () {
        var now = new Date().getTime();
        _this.distance = countDownDate - now;
        if (_this.distance < 0) {
          clearInterval(_this.timerInterval);
        }
      }, 1000);
    },
    async copyText(text) {
      try {
        await navigator.clipboard.writeText(text);
        this.snackbar.show = true;
        this.snackbar.color = "success";
        this.snackbar.text = "Number was copied successful";
      } catch (err) {
        this.snackbar.show = true;
        this.snackbar.color = "error";
        this.snackbar.text = "Oops, unable to copy";
      }
    },
    async handleCheckUpdate() {
      // this.$store.dispatch("set_router_data", { name: 'order-detail', params: { order_id: this.orderData.id } });
      this.loading_payment = true;
      try {
        const { data } = await getSelfOrder(this.orderData.id).then(
          (res) => res.data
        );
        this.$store.dispatch("create_order", data);
        if (data.is_paid) {
          this.$store.dispatch("removeAllReservation");
          this.$store.dispatch("set_router_data", { name: 'order-detail', params: { order_id: data.id } });
          setQueryParam('page', 'order-detail')
          setQueryParam('order_id', data.id)
        }
      } catch (e) {
        this.$store.state.show_error = true;
        this.$store.state.error_message = e.string;
        this.$store.state.error_type = e.statusCode;
      } finally {
        this.$store.state.loading_axios = false;
        this.loading_payment = false;
      }
    },
    async cancelOrderReservation() {
      this.loading_payment = true;
      this.dialog.dialogCancelOrder = true;
      try {
        await cancelOrder(this.orderData.id);
        this.dataSuccess.show = true;
        this.dataSuccess.message = "Pesanan berhasil dibatalkan";
        this.dialog.dialogCancelOrder = false;
        setTimeout(() => {
          removeAllQueryParams()
          this.$store.dispatch("remove_order");
          this.$store.dispatch("removeAllReservation");
        }, 3000);
      } catch (e) {
        this.$store.state.show_error = true;
        this.$store.state.error_message = e.string;
        this.$store.state.error_type = e.statusCode;
      } finally {
        this.$store.state.loading_axios = false;
        this.loading_payment = false;
        this.dialog.dialogCancelOrder = false;
      }
    },
    backToHome() {
      removeAllQueryParams()
        this.$store.dispatch("remove_order");
        this.$store.dispatch("removeAllReservation");
    },
  },
};
</script>

<style>.main-container {
  gap: 0 !important;
}

.va-card-number {
  color: #000000 !important;
  font-weight: 500;
  margin-bottom: 8px !important;
}</style>
